import { faLeaf } from "@fortawesome/duotone-regular-svg-icons/faLeaf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Group, Stack, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { createLogger } from "../utils/logger";

const logger = createLogger("LeaveNoTraceModal");

const LEAVE_NO_TRACE_MODAL_ID = "leave-no-trace";
const LNT_SHOWN_KEY = "iwannacamp-lnt-shown";

const hasShownLeaveNoTrace = (): boolean => {
  try {
    return localStorage.getItem(LNT_SHOWN_KEY) === "true";
  } catch {
    return false;
  }
};

const markLeaveNoTraceShown = (): void => {
  try {
    localStorage.setItem(LNT_SHOWN_KEY, "true");
  } catch {
    logger.error("Failed to save Leave No Trace modal state");
  }
};

const openLeaveNoTraceModal = (onClose?: () => void) => {
  modals.open({
    modalId: LEAVE_NO_TRACE_MODAL_ID,
    title: (
      <Group gap="xs">
        <FontAwesomeIcon icon={faLeaf} />
        <span>Protect Our Wild Spaces</span>
      </Group>
    ),
    withCloseButton: true,
    centered: true,
    size: "lg",
    onClose: () => {
      markLeaveNoTraceShown();
      onClose?.();
    },
    children: (
      <Stack gap="md" p="md">
        <Text>
          Before you head out camping, we encourage you to learn about{" "}
          <strong>Leave No Trace</strong> outdoor ethics.
        </Text>

        <Text size="sm">
          Leave No Trace is a national program dedicated to protecting the
          outdoors by teaching people to enjoy nature responsibly. Their
          research-based principles help minimize human impact on our natural
          spaces, ensuring they remain beautiful and accessible for future
          generations.
        </Text>

        <Text size="sm">
          Whether you're camping, hiking, or simply enjoying nature,
          understanding these principles will help you:
        </Text>

        <Text size="sm" pl="md" component="div">
          • Protect wildlife and fragile ecosystems
          <br />
          • Preserve the natural experience for other visitors
          <br />
          • Keep our public lands clean and healthy
          <br />• Be a responsible outdoor steward
        </Text>

        <Button
          component="a"
          href="https://lnt.org/why/7-principles/"
          target="_blank"
          rel="noopener noreferrer"
          variant="filled"
          leftSection={<FontAwesomeIcon icon={faLeaf} />}
        >
          Visit LNT.org to learn more
        </Button>

        <Group justify="flex-end" mt="sm">
          <Button
            variant="light"
            onClick={() => {
              modals.close(LEAVE_NO_TRACE_MODAL_ID);
            }}
          >
            Got it!
          </Button>
        </Group>
      </Stack>
    ),
    styles: {
      title: {
        flex: 1,
      },
      header: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  });
};

export {
  hasShownLeaveNoTrace,
  LEAVE_NO_TRACE_MODAL_ID,
  markLeaveNoTraceShown,
  openLeaveNoTraceModal
};

